import {
  Component,
  EventEmitter,
  Injector,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
  CreateOrEditDelegateDto,
  GetStaffAndUserListViewDto,
  PagedResultDtoOfGetStaffAndUserListViewDto,
  StaffsAndUsersServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import * as moment from 'moment';
import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { I } from '@angular/cdk/keycodes';
import { PermissionCheckerService } from 'abp-ng2-module';

@Component({
  selector: 'delegateActivityModal',
  templateUrl: './delegate-activity-modal.component.html',
  styleUrls: ['delegate-activity-modal.component.less'],
})
export class DelegateActivityModalComponent
  extends AppComponentBase
  implements OnInit, OnDestroy {
  searchForm: FormGroup = new FormGroup({
    search: new FormControl(),
  });

  delegationSupervisor: GetStaffAndUserListViewDto;
  supervisorList: GetStaffAndUserListViewDto[] = [];
  showList = false;
  delegationId;

  startDate : Date;
  endDate : Date;
  bsConfig = new BsDaterangepickerConfig();

  @ViewChild('modal', { static: true }) modal: ModalDirective;
  options: any;

  @Output() clearDelegation$: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  delegate$: EventEmitter<CreateOrEditDelegateDto> = new EventEmitter<CreateOrEditDelegateDto>();

  private searchSubscription: Subscription = new Subscription();

  permissionFilter: string;

  constructor(
    injector: Injector,
    private _staffsAndUsersServiceProxy: StaffsAndUsersServiceProxy,
    private _projectService : ProjectService,
    private _permissionChecker: PermissionCheckerService,
    private _sessionService : AppSessionService,
  ) {
    super(injector);

    this.bsConfig.displayMonths = 1;
    this.bsConfig.showWeekNumbers = false;
    this.bsConfig.containerClass = 'custom-datapicker';
  }

  ngOnInit(): void {
    this.searchSubscription = this.searchForm
      .get('search')
      .valueChanges.pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        if (value) {
          this.getSupervisors();
        } else {
          this.supervisorList = [];
        }
      });
      if(this._permissionChecker.isGranted('Pages.AllocationSheets.Foreman')){
        this.permissionFilter = 'Pages.AllocationSheets.Foreman'
      }
      else if(this._permissionChecker.isGranted('Pages.AllocationSheets.Supervisor')){
        this.permissionFilter = 'Pages.AllocationSheets.Supervisor'
      }
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  selectDate(event: any, calendar: any) {

    //Start Date
    if(this.startDate == null)
    {
      this.startDate = event;
    }
    else if(this.startDate > event )
    {
      this.startDate = event;
    }
    else if(this.startDate.getTime()===event.getTime())
    {
      this.startDate= this.startDate.getTime()===this.endDate.getTime()?null:this.endDate;
    }

    //End Date
    if(this.endDate == null)
    {
      this.endDate = event;
    }
    else if(this.endDate < event )
    {
      this.endDate = event;
    }
    else if(this.startDate < event && this.endDate > event)
    {
      this.endDate = event;
    }
    else if(this.endDate.getTime()===event.getTime())
    {
      this.endDate= this.startDate.getTime()===this.endDate.getTime()?null:this.startDate;
    }

    calendar.updateTodaysDate();
  }

  isSelected = (event: any) => {

    const eventDateText = event.getFullYear() +
      '-' +
      ('00' + (event.getMonth() + 1)).slice(-2) +
      '-' +
      ('00' + event.getDate()).slice(-2);

      if(this.startDate != null)
      {
        const startDateText = this.startDate.getFullYear() +
          '-' +
          ('00' + (this.startDate.getMonth() + 1)).slice(-2) +
          '-' +
          ('00' + this.startDate.getDate()).slice(-2);

          if(eventDateText ==  startDateText)
          {
            return 'selected';
          }
      }

      if(this.endDate != null)
      {
        const endDateText = this.endDate.getFullYear() +
          '-' +
          ('00' + (this.endDate.getMonth() + 1)).slice(-2) +
          '-' +
          ('00' + this.endDate.getDate()).slice(-2);

          if(eventDateText == endDateText)
          {
            return 'selected';
          }
      }

      return null;
  };

  onDateValueChange(dates: Date[]): void {
    if(dates.length == 2)
    {
    this.startDate = dates[0];
    this.endDate = dates[1];
    }
  }

  show(options: any): void {
    this.options = options;
    this.modal.show();

    if (options?.delegationDestStaffId) {

      this.startDate = new Date(options.startDate);
      this.endDate = new Date(options.endDate);
      this.delegationId = options.id;

      this.getSelectedSupervisor(options.delegationDestStaffId);
    }
  }

  close(): void {
    this.searchForm.reset();
    this.delegationSupervisor = null;
    this.supervisorList = [];
    this.showList = false;
    this.delegationId = null;
    this.startDate = null;
    this.endDate = null;

    this.modal.hide();
  }

  async delegate() {
    const projectId = await this._projectService.getCurrentOrDefaultProjectId();
    const body = new CreateOrEditDelegateDto();
    body.startDate = moment(this.startDate).startOf('day');
    body.endDate = moment(this.endDate).endOf('day');
    body.delegationDestStaffId = this.delegationSupervisor.staffUser.staffId;
    body.id = this.delegationId;
    body.projectId = projectId;
    this.delegate$.emit(body);
    this.close();
  }

  clearDelegation(): void {
    this.clearDelegation$.emit();
    this.close();
  }

  IsDateAvilabel(): boolean{
    if(this.startDate != null)
    {
      return true;
    }

    return false;
  }

  selectSupervisor(supervisor: GetStaffAndUserListViewDto): void {
    this.delegationSupervisor = supervisor;
    this.showList = false;
    this.supervisorList = [];
    this.searchForm.get('search').reset();
  }

  getSupervisorFullName(supervisor: GetStaffAndUserListViewDto): string {
    return `${supervisor?.staffUser?.firstName} ${supervisor?.staffUser?.lastName}`;
  }

  private getSupervisors(
    getActive: boolean = false,
    delegationDestStaffId?: number
  ): void {
    this.showList = false;

    this._staffsAndUsersServiceProxy
    .getAllStaffAndUsersForDelegation(
      this.permissionFilter, // Foreman or Supervisor
      this.searchForm.get('search').value,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      0,
      999999,
    )
      .pipe(
        map((data: PagedResultDtoOfGetStaffAndUserListViewDto) => data.items)
      )
      .subscribe((data: GetStaffAndUserListViewDto[]) => {
        let list = data;

        if (getActive) {
          this.delegationSupervisor = list.find(
            (staff: GetStaffAndUserListViewDto) =>
              staff.staffUser.staffId === delegationDestStaffId
          );
        } else {
          if (this.delegationSupervisor) {
            list = data?.filter(
              (staff: GetStaffAndUserListViewDto) =>
                Number(staff.staffUser.staffId) !==
                Number(this.delegationSupervisor?.staffUser.staffId)
            );
          }

          this.supervisorList = list;
          this.showList = true;
        }
      });
  }

  private getSelectedSupervisor(delegationDestStaffId: number): void {
    this.getSupervisors(true, delegationDestStaffId);
  }

  private setTomorrowDate(): void {
    const today = new Date();
    const tomorrow = new Date(today);

    tomorrow.setDate(tomorrow.getDate() + 1);
  }
}
